import {z} from 'zod';

import {FinancialProductMoneySchema} from './FinancialProductMoneySchema';
import {LeasingTargetGroupSchema} from './LeasingTargetGroupSchema';

export const FinancialProductCalculationSchema = z.object({
  termMonths: z.number(),
  monthlyPayment: FinancialProductMoneySchema,
  downPaymentPercentage: z.number().nullable(),
  downPaymentAmount: FinancialProductMoneySchema.nullable(),
  netCredit: FinancialProductMoneySchema.nullable(),
  grossCredit: FinancialProductMoneySchema.nullable(),
  totalInterest: FinancialProductMoneySchema.nullable(),
  totalPayable: FinancialProductMoneySchema.nullable(),
  nominalRate: z.string().nullable(),
  apr: z.string().nullable(),
  balloonPaymentPercentage: z.number().nullable(),
  balloonPaymentAmount: FinancialProductMoneySchema.nullable(),
  leasingTargetGroup: LeasingTargetGroupSchema.nullable(),
  annualMileage: z.number().nullable(),
  leasingDownPayment: FinancialProductMoneySchema.nullable(),
  monthlyPaymentMode: z.enum(['GROSS', 'NET']).nullable(),
  /**
   * Leasing only: `monthlyPayment` plus the offer's monthly services as entered. Null on financing
   * and whenever the leasing costs are not known. Absent from an older backend reads as null, so a
   * stored quote equals its local twin (ramda `equals`).
   */
  leasingTotalMonthlyPayment: FinancialProductMoneySchema.nullable().default(null),
  /**
   * Leasing only: `leasingTotalMonthlyPayment` over the term plus the leasing down payment; null
   * exactly when that monthly total is. Absent from an older backend reads as null, as above.
   */
  leasingTotalForTerm: FinancialProductMoneySchema.nullable().default(null),
});
export type FinancialProductCalculation = z.infer<typeof FinancialProductCalculationSchema>;
